import { render, staticRenderFns } from "./FieldMapping.vue?vue&type=template&id=67511a70&"
import script from "./FieldMapping.vue?vue&type=script&lang=ts&"
export * from "./FieldMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports